import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

import { environment } from '../environments/environment';

import { AuthMode } from './auth-mode.constant';
import { SessionManagerErrorData } from './auth.abstraction';
import {
  SERVICE_UNREACHABLE_STATUS_CODES,
  SESSION_MANAGER_INVALID_INPUT_CODE,
  SESSION_MANAGER_SESSION_EXPIRED_DETAILS,
} from './auth.constant';

export class AuthUtility {
  static isServiceUnreachableError(error: unknown): boolean {
    const isHttpError = error instanceof HttpErrorResponse;

    return isHttpError
      && SERVICE_UNREACHABLE_STATUS_CODES.includes(error.status);
  }

  static isSessionLostError(error: unknown): boolean {
    const isSessionLost = this.isUnauthorizedError(error)
      || this.isSessionManagerExpiredError(error);

    return isSessionLost;
  }

  static isSessionManagerMode(): boolean {
    return environment.auth.mode === AuthMode.SessionManager;
  }

  static isUnauthorizedError(error: unknown): boolean {
    const isHttpError = error instanceof HttpErrorResponse;

    return isHttpError
      && error.status === HttpStatusCode.Unauthorized;
  }

  private static isSessionManagerExpiredError(error: unknown): boolean {
    const isBadRequestError = this.isSessionManagerMode()
      && error instanceof HttpErrorResponse
      && error.status === HttpStatusCode.BadRequest;

    if (!isBadRequestError) {
      return false;
    }

    const errorData = error.error as Partial<SessionManagerErrorData> | null;
    const isSessionExpired = errorData?.code === SESSION_MANAGER_INVALID_INPUT_CODE
      && errorData.details?.includes(SESSION_MANAGER_SESSION_EXPIRED_DETAILS) === true;

    return isSessionExpired;
  }
}
